import { JsonSchema, UISchemaElement } from '@jsonforms/core';

type ExtendedUISchemaElement = UISchemaElement & {
  scope?: string;
};

export const getTrueFields = (
  elements: ExtendedUISchemaElement[] | undefined,
  schema: JsonSchema | undefined,
  data: Record<string, unknown> | undefined
): string[] => {
  return (
    elements
      ?.map(element => {
        if (!element.scope) {
          return null;
        }
        const fieldName = element.scope.replace('#/properties/', '');
        const isBoolean = schema?.properties?.[fieldName]?.type === 'boolean';
        const isTrue = data?.[fieldName] === true;

        if (isBoolean && isTrue) {
          return schema?.properties?.[fieldName]?.title || null;
        }
        return null;
      })
      .filter((value): value is string => typeof value === 'string') || []
  );
};
